import { Link } from 'react-router-dom';
import { sidebarIconsUrlData, sidebarLinkData } from '@/lib/main';
import { useLocation } from 'react-router-dom';
import React, { FC } from 'react';

interface IconsProps {
  hoveredIndex: number | null;
  setHoveredIndex: (index: number | null) => void;
}

const Icons: FC<IconsProps> = ({ hoveredIndex, setHoveredIndex }) => {
  const { pathname } = useLocation();

  const permissionRoutes = JSON.parse(
    localStorage.getItem('permissionRoutes') || '[]'
  );
  permissionRoutes.push('/nms', '/report');
  const cleanPath = (path: string) => path.replace(/\//g, '');
  const getUrlBase = (url: string) => {
    return url.split('/').filter(Boolean)[0];
  };

  const handleMouseEnter = (index: number) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  return (
    <>
      <Link
        to="/"
        className="bg-[#1141A5] h-[75px] w-full flex items-center justify-center">
        <img
          width="auto"
          className="max-h-[30px] lg:max-h-[40px]"
          src="/assets/images/sidebar/logo.png"
          loading="lazy"
        />
      </Link>
      {sidebarLinkData
        .map((link, index) => ({ ...link, icon: sidebarIconsUrlData[index] })) // Combine icon with link data
        .filter((link) =>
          permissionRoutes.some(
            (route: string) => cleanPath(route) === cleanPath(link.to)
          )
        ) // Filter based on permissionRoutes
        .map((link, index) => (
          <Link
            key={`${link.to}_${index}`}
            onClick={(e) => {
              if (link.title === 'NMS') {
                e.preventDefault();
                e.stopPropagation();
                window.open('https://wnms.gomatimvvnl.in/nms');
              } else if (link.title === 'REPORT') {
                e.preventDefault();
                e.stopPropagation();
                window.open('https://grafana.gomatimvvnl.in/');
              }
            }}
            to={link.to}
            className={`rounded-l-lg group-hover:ml-3 h-[55px] w-full flex items-center justify-center sidebar-item-${index}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}>
            <div className="w-[30px] h-[30px] lg:w-[45px] lg:h-[45px] flex items-center justify-center rounded-lg sidebar-icon">
              {link.icon
                ? React.createElement(link.icon, {
                    id: `sidebar-icon-${index}`,
                    fill:
                      hoveredIndex === index ||
                      getUrlBase(pathname) === getUrlBase(link.to)
                        ? 'currentColor'
                        : '',
                    className:
                      hoveredIndex === index ||
                      getUrlBase(pathname) === getUrlBase(link.to)
                        ? 'current-route-sidebar'
                        : ''
                  })
                : null}
            </div>
          </Link>
        ))}
    </>
  );
};

export default Icons;
